import React from "react";

import clsx from "clsx";
import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-sales-prospect-qualification.png";

import HeroSection from "../../hero-section";
import styles from "./index.module.css";
import TimelineContent from "./timeline-content";

const title = "Qualification";

const Qualification = () => (
  <div className={clsx("timeline-section-wrapper", styles.timelineSectionWrapper)}>
    <HeroSection title={title} className={styles.timelineSection}>
      <div className={styles.timelineSectionGrid}>
        <figure className={styles.timelineFigure}>
          <div className="w-1/2 xs:w-2/5 md:w-full mx-auto">
            <Image
              src={FigureImage}
              alt="Setters can qualify prospects door-to-door with their favorite canvassing apps that integrate with the Enerflo Solar Platform."
              layout="responsive"
              quality={100}
              placeholder="blur"
              className="crispImage"
              sizes="(min-width: 768px) 50vw, 100vw"
              lazyBoundary="400px"
            />
          </div>
        </figure>
        <TimelineContent
          title={title}
          description="Qualify prospects door-to-door with popular canvassing apps that integrate intelligently with Enerflo. Setters can instantly move customer details to Enerflo."
          link="/integrations/sales-qualification"
          offsetFigure
          icon={
            <Image
              src="/images/icons/qualification.svg"
              alt="Icon - Enerflo Qualification"
              layout="responsive"
              height={63}
              width={53}
              quality={100}
              className="crispImage"
            />
          }
        />
      </div>
    </HeroSection>
  </div>
);
export default Qualification;
